import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-5 has-text-weight-bold" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "is-size-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.quizTitle), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.question.position_in_quiz) + " out of " + _toDisplayString(_ctx.questionsPerQuiz), 1)
    ])
  ], 64))
}